<div class="dashboard-container">
    <div class="dashboard-cards">
        <mat-card class="dashboard-card" (click)="navigateToManageJobCards()">
            <mat-icon class="dashboard-icon">assignment</mat-icon>
            <h2>Manage Job Cards</h2>
            <p>Manage and Edit Job Cards</p>
        </mat-card>

        <mat-card class="dashboard-card" (click)="navigateToCreateComplaint()">
            <mat-icon class="dashboard-icon">report</mat-icon>
            <h2>Create Complaint</h2>
            <p>Create User complaints</p>
        </mat-card>
    </div>
</div>
